import type { ReactNode } from 'react';

export interface UserTableColumn<T> {
  render: (row: T) => ReactNode;
  align?: 'left' | 'center' | 'right';
  width?: string;
  whiteSpace?: React.CSSProperties['whiteSpace'];
}

interface UserTableProps<T> {
  rows: T[];
  columns: UserTableColumn<T>[];
}

const TD: React.CSSProperties = { padding: '10px 14px', fontSize: '13px', color: '#374151' };

export function UserTable<T>({ rows, columns }: UserTableProps<T>) {
  return (
    <div style={{ backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {columns.map((col, j) => (
                <td key={j} style={{ ...TD, textAlign: col.align ?? 'left', width: col.width, whiteSpace: col.whiteSpace }}>
                  {col.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
